export default __webpack_public_path__ + "static/media/unit-result-3.ffccdb6d.mp3";